<script>
  export let text
</script>

<div class="jse-tooltip">
  {text}
</div>

<style src="./Tooltip.scss"></style>
